export const QueryTags = {
  HotelDetail: 'HotelDetail',
  HotelDetailGallery: 'HotelDetailGallery',
  HotelList: 'HotelList',
  HotelRoomDetail: 'HotelRoomDetail',
  HotelRoomList: 'HotelRoomList',
  HotelRoomDetailGallery: 'HotelRoomDetailGallery',
  PeaksConfig: 'PeaksConfig',
};
